/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change language`)
};

const zh_hans1_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换语言`)
};

const zh_hant1_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切換語言`)
};

const fr_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de langue`)
};

const de_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache ändern`)
};

const ja_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語を変更`)
};

const ko_aria_change_language = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언어 변경`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const aria_change_language = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.aria_change_language(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("aria_change_language", locale)
	if (locale === "en") return en_aria_change_language(inputs)
	if (locale === "zh-Hans") return zh_hans1_aria_change_language(inputs)
	if (locale === "zh-Hant") return zh_hant1_aria_change_language(inputs)
	if (locale === "fr") return fr_aria_change_language(inputs)
	if (locale === "de") return de_aria_change_language(inputs)
	if (locale === "ja") return ja_aria_change_language(inputs)
	return ko_aria_change_language(inputs)
};